module.exports = __webpack_public_path__ + "static/img/Wilmot.d86779b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Wilmot.jpg
// module id = Rq+1
// module chunks = 0